export { Modal } from './modal';
export { VEXModalContext, VEXModalContextBuilder } from './modal-context';
export { DropInPreset, DropInPresetBuilder } from './presets/dropin-preset';
export { DialogFormModal, FormDropIn, VEXDialogButtons } from './dialog-form-modal';
export { DialogPreset, DialogPresetBuilder } from './presets/dialog-preset';
export { VexModalModule, providers } from './vex.module';
//# sourceMappingURL=vex.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/plugins/vex/src/vex.js
// module id = 17
// module chunks = 0